import {
  StopIcon,
  StartIcon,
  ContinueIcon,
  TagSkillIcon,
  SelfReviewIcon,
  CompleteSurveyIcon
} from "src/assets/";

export const NoRatedView = [
  {
    icon: <TagSkillIcon />,
    title: "Tag a skill",
    desc: "1. To generate a skill rating, tag a skill on this target & create skills rating check-in."
  },
  {
    icon: <SelfReviewIcon />,
    title: "Self review or assign people",
    desc: "2. Complete check-in as a self-review or assign people to provide feedback on development of a skills."
  },
  {
    icon: <CompleteSurveyIcon />,
    title: "Complete skill rating survey",
    desc: "3. After completing the skills rating survey your results will show up here for yourself or team."
  }
];

export const NoDataValue = [
  {
    type: "Stop",
    icon: <StopIcon />,
    title: "Good news!",
    desc: "You are not actively doing anything to get in the way of leveraging this skill."
  },
  {
    type: "Start",
    icon: <StartIcon />,
    title: "Yippie!",
    desc: "No news is good news! You are already doing the things you should be for this skill."
  },
  {
    type: "Continue",
    icon: <ContinueIcon />,
    title: "Uh-oh!",
    desc: "Check out our suggestions for ways to effectively demonstrate this skill."
  }
];
